module.exports = "<div leafleat id=\"map\" style=\"width:1024px;height:400px;\"></div>\n\nposition: absolute;\nleft: 0px;\ntop: 0px;\nz-index: -1;"